import type { ActiveContract, FlexibilitySuppliers, Site, SiteReading, SiteReport, SiteReports, SiteSummary, SiteUnavailability } from '../../types';

import { createSlice } from '@reduxjs/toolkit';

import { extraReducers, reducers } from './reducer';

export interface SiteState {
  loading: boolean;
  sites: Site[];
  sitesReading: SiteReading[];
  siteReport: SiteReport[];
  siteReports: SiteReports;
  siteReportsLoading: boolean;
  siteSummary: SiteSummary | null;
  selectedSites: Site['siteId'][];
  selectedSiteCalendar: Site | null;
  selectedYear: number;
  previousSelectedYear: number;
  selectedSite?: Site['siteId'];
  previousSelectedSite: Site['siteId'];
  sitesUnavailabilitiesLoading: boolean;
  sitesUnavailabilities: SiteUnavailability[];
  siteByYearLoading: boolean;
  activeContracts: ActiveContract | null;
  flexSupplier: FlexibilitySuppliers | null;
}

const initialState: SiteState = {
  loading: false,
  sites: [],
  sitesReading: [],
  siteReport: [],
  siteReports: [],
  siteReportsLoading: false,
  siteSummary: null,
  selectedSites: [],
  selectedYear: new Date().getFullYear(),
  previousSelectedYear: 0,
  selectedSite: undefined,
  previousSelectedSite: '',
  selectedSiteCalendar: null,
  sitesUnavailabilitiesLoading: false,
  sitesUnavailabilities: [],
  siteByYearLoading: false,
  activeContracts: null,
  flexSupplier: null,
};

export const siteSlice = createSlice({
  name: 'site',
  initialState,
  reducers,
  extraReducers,
});

export const siteSelector = (state: { site: SiteState }) => state.site;
export const siteReducer = siteSlice.reducer;
export const siteActions = siteSlice.actions;

export const {
  setSiteLoading,
  addOrRemoveSelectedSites,
  setSelectedYear,
  setPreviousSelectedYear,
  setSelectedSite,
  setSelectedSiteCalendar,
  setPreviousSelectedSite,
  setSitesUnavailabilitiesLoading,
} = siteSlice.actions as (typeof siteSlice)['actions'];
